import InboxPage from './components/InboxPage';

export default InboxPage;
